import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";

import {
  getWatchListUpdateLogs,
  getWatchListUpdateLogsCount,
  setCurrentPage,
  setItemsPerPage,
} from "../../actions";
import {
  pageInfoSelector,
  selector,
  watchListUpdateLogsLoadingSelector,
} from "../../selectors";
import WatchListUpdateReportTable from "./table";

import "./WatchListUpdateReport.css";
import Pagination from "../../../../components/Pagination/Pagination";
import PageTitle from "../../../../components/common/PageTitle";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";

const WatchListUpdateReportPage = () => {
  const watchListUpdateLogs = useSelector(selector);
  const { count, itemsPerPage, currentPage } = useSelector(pageInfoSelector);
  const isLoading = useSelector(watchListUpdateLogsLoadingSelector);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getWatchListUpdateLogsCount());
  }, []);


  useEffect(() => {
    if (count > 0) {
      dispatch(getWatchListUpdateLogs({ take: itemsPerPage }));
    }
  }, [count]);

  const onPageChange = (_, page) => {
    dispatch(setCurrentPage(page + 1));
    const skip = page * itemsPerPage;
    dispatch(getWatchListUpdateLogs({ take: itemsPerPage, skip }));
  };

  const onRowsPerPageChange = ({ target }) => {
    dispatch(setCurrentPage(1));
    dispatch(getWatchListUpdateLogs({ take: target.value, skip: 0 }));
    dispatch(setItemsPerPage(target.value));
  };

  return (
    <div>
      <PageTitle title={"watchlist updates"} />
      <FullscreenLoader loading={isLoading} />

      <Container
        className="watch-list-report-page-container col-12"
        tabIndex="0"
      >
        {watchListUpdateLogs.length > 0 && (
          <React.Fragment>
            <WatchListUpdateReportTable
              watchListUpdateLogs={watchListUpdateLogs}
            />
            {/* {count > itemsPerPage && ( if paginations needs to be hidden */}
            {count && (
              <Row className="pagination-row mt-5 mb-5">
                <Pagination
                  count={count}
                  onPageChange={onPageChange}
                  onRowsPerPageChange={onRowsPerPageChange}
                  rowsPerPage={itemsPerPage}
                  page={currentPage - 1}
                />
              </Row>
            )}
          </React.Fragment>
        )}
      </Container>
    </div>
  );
};

export default WatchListUpdateReportPage;



// WEBPACK FOOTER //
// ./src/features/reports/pages/watch-list-update-report/WatchListUpdateReportPage.jsx